import { apiRequest } from "../../services/request";
import { ApiResponse } from "../../types/api.types";

export interface IGetEmployeePayload {
  search?: string;
  status: string;
  page: number;
  limit?: number;
  isDownload?: boolean;
  password?: string;
  branchId?: string;
  shiftId?: string;
  departmentId?: string;
  role?: string;
}

export const getEmployees = (payload: IGetEmployeePayload) => {
  const {
    page,
    limit,
    search,
    status,
    isDownload = false,
    password = "",
    branchId,
    shiftId,
    departmentId,
    role,
  } = payload;
  return apiRequest.get<ApiResponse>(
    `/workforce/employee?page=${page}${limit ? `&limit=${limit}` : ""}${search ? `&search=${search}` : ""}${status ? `&status=${status}` : ""}${branchId ? `&branchId=${branchId}` : ""}${shiftId ? `&shiftId=${shiftId}` : ""}${departmentId ? `&departmentId=${departmentId}` : ""}${role ? `&role=${role}` : ""}${isDownload ? `&isDownload=${isDownload}` : ""}${password ? `&csvPassword=${password}` : ""}`,
  );
};

export const getEmployeeById = (userId: string) => {
  return apiRequest.get<ApiResponse>(`/workforce/employee/${userId}`);
};

export const updateEmployee = (payload: any, userId: string = "") =>
  apiRequest.put(`workforce/employee/${userId}`, payload, {
    showSuccessToast: true,
  });

export const updateEmployeeStatus = (
  payload: {
    status: string;
    remarks: string;
  },
  userId: string = "",
) =>
  apiRequest.patch(`/workforce/onboard/status/${userId}`, payload, {
    showSuccessToast: true,
  });

export const getEmployeeCount = () => {
  return apiRequest.get<ApiResponse>(`/workforce/employee/count`);
};

export const getManagedEmployee = (branchId: string) => {
  return apiRequest.get<ApiResponse>(
    `/workforce/employee/my-managed?branchId=${branchId}`,
  );
};

export const getCompanyDetails = () => {
  return apiRequest.get<ApiResponse>(`/workforce/company-details`);
};

export const getEmployeeSalary = (userId: string) => {
  return apiRequest.get<ApiResponse>(
    `/workforce/employee/salary?userId=${userId}`,
  );
};

export interface IEmployeeSalaryPayload {
  payslipId: string;
  userId: string;
  salary: number;
  effectiveFromMonth: number;
  effectiveFromYear: number;
  remarks: string;
  allowPFDeduction: boolean;
  allowESICDeduction: boolean;
}
export const updateEmployeeSalary = (payload: IEmployeeSalaryPayload) => {
  return apiRequest.post(`/workforce/employee/salary`, payload);
};
